import { render, staticRenderFns } from "./PsychologistAvatar.vue?vue&type=template&id=9525600e&scoped=true"
import script from "./PsychologistAvatar.vue?vue&type=script&lang=js"
export * from "./PsychologistAvatar.vue?vue&type=script&lang=js"
import style0 from "./PsychologistAvatar.vue?vue&type=style&index=0&id=9525600e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9525600e",
  null
  
)

export default component.exports